import { createAction } from '@reduxjs/toolkit';

import { SET_PURCHASE_PARAMS, type PurchaseParams } from './types';

export const setPurchaseParams = createAction<PurchaseParams, typeof SET_PURCHASE_PARAMS>(
	SET_PURCHASE_PARAMS,
);
